// @ts-strict-ignore
import { TranslationKey } from '@tolgee/ngx';
import { UI_STRINGS } from '../../../functions/language/uistrings';
import { TransitionElement } from '../../../model/enums/transition-element';

export enum ModelTranslationOutputType {
  CarbonCausalChain = 'carbonCausalChain',
  CoBenefit = 'coBenefit',
  EconomicCategory = 'economicCategory',
  Resource = 'resource',
  TransitionElementTitle = 'transitionElementTitle',
  TransitionElementShortName = 'transitionElementShortName',
  TransitionElementDescription = 'transitionElementDescription',
  TransitionElementActvityShiftDescription = 'transitionElementActivityShiftDescription',
  TransitionElementParameterUpdateLeverDescription = 'transitionElementParameterUpdateLeverDescription',
  TransitionElementMethodFrom = 'transitionElementMethodFrom',
  TransitionElementMethodTo = 'transitionElementMethodTo',
  TransitionElementProportionalLeverTargetDescription = 'transitionElementProportionalLeverTargetDescription',
  TransitionElementAbsoluteLeverTargetDescription = 'transitionElementAbsoluteLeverTargetDescription',
  TransitionElementOperationsInScopeDescription = 'transitionElementOperationsInScopeDescription',
  Unit = 'unit',
  VariableTitle = 'variableTitle',
}

export function generateModelTranslationKey(
  outputType: ModelTranslationOutputType,
  input: TransitionElement | string
): TranslationKey {
  const upperCasedInput = input?.toUpperCase();
  switch (outputType) {
    case ModelTranslationOutputType.CarbonCausalChain:
      return UI_STRINGS.MODEL.CCC[upperCasedInput];
    case ModelTranslationOutputType.CoBenefit:
      return UI_STRINGS.MODEL.CO_BENEFITS[upperCasedInput];
    case ModelTranslationOutputType.EconomicCategory:
      return UI_STRINGS.MODEL.ECONOMIC_CATEGORY[upperCasedInput];
    case ModelTranslationOutputType.Resource:
      return UI_STRINGS.MODEL.RESOURCES[upperCasedInput];
    case ModelTranslationOutputType.TransitionElementTitle:
      return UI_STRINGS.MODEL.TRANSITION_ELEMENT_TITLE[upperCasedInput];
    case ModelTranslationOutputType.TransitionElementShortName:
      return UI_STRINGS.MODEL.TRANSITION_ELEMENT_SHORT_NAME[upperCasedInput];
    case ModelTranslationOutputType.TransitionElementDescription:
      return UI_STRINGS.MODEL.TRANSITION_ELEMENT_DESCRIPTION[upperCasedInput];
    case ModelTranslationOutputType.TransitionElementActvityShiftDescription:
      return UI_STRINGS.MODEL.TRANSITION_ELEMENT_ACTIVITY_SHIFT_DESCRIPTION[upperCasedInput];
    case ModelTranslationOutputType.TransitionElementParameterUpdateLeverDescription:
      return UI_STRINGS.MODEL.TRANSITION_ELEMENT_PARAMETER_UPDATE_LEVER_DESCRIPTION[upperCasedInput];
    case ModelTranslationOutputType.TransitionElementMethodFrom:
      return UI_STRINGS.MODEL.TRANSITION_ELEMENT_METHOD_FROM[upperCasedInput];
    case ModelTranslationOutputType.TransitionElementMethodTo:
      return UI_STRINGS.MODEL.TRANSITION_ELEMENT_METHOD_TO[upperCasedInput];
    case ModelTranslationOutputType.TransitionElementProportionalLeverTargetDescription:
      return UI_STRINGS.MODEL.TRANSITION_ELEMENT_PROPORTIONAL_LEVER_TARGET_DESCRIPTION[upperCasedInput];
    case ModelTranslationOutputType.TransitionElementAbsoluteLeverTargetDescription:
      return UI_STRINGS.MODEL.TRANSITION_ELEMENT_ABSOLUTE_LEVER_TARGET_DESCRIPTION[upperCasedInput];
    case ModelTranslationOutputType.TransitionElementOperationsInScopeDescription:
      return UI_STRINGS.MODEL.TRANSITION_ELEMENT_OPERATIONS_IN_SCOPE_DESCRIPTION[upperCasedInput];
    case ModelTranslationOutputType.Unit:
      return UI_STRINGS.MODEL.UNIT[upperCasedInput];
    case ModelTranslationOutputType.VariableTitle:
      return UI_STRINGS.MODEL.VARIABLE_TITLE[upperCasedInput];
    default:
      return undefined;
  }
}
